import React from 'react';
import i18n from '../../../i18n';
import { useSelector } from 'react-redux';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useRouterParam } from 'core/router/router';
import { useAction, useActionDispatchOnMount } from 'core/store/store';

import { makeOrderChangeStatusAction, makeOrderFetchItemRequestAction } from 'state/order/actions';
import { orderCurrentItemSelector } from 'state/order/selector';
import { isUIEnabledSelector } from 'state/app/selectors';

import { Dialog } from 'components/Dialog/Dialog';
import { ErrorBoundary } from 'components/ErrorBoundary';
import { OrderCard } from 'components/OrderCard/OrderCard';
import { OrderCustomerPhone } from './OrderCustomerPhone';

import { UserRole } from 'types';

import css from './OrdersDefaultDialog.module.css';

export interface OrdersDefaultDialogProps {
    onClose: () => void;
}

export const OrdersDefaultDialog = (props: OrdersDefaultDialogProps) => {
    const { t } = i18n.useTranslation();
    const id = useRouterParam('orderId');
    useActionDispatchOnMount(true, makeOrderFetchItemRequestAction, id);
    const order = useSelector(orderCurrentItemSelector);
    const action = useAction();

    const isUIEnabled = useSelector(isUIEnabledSelector);

    return (
        <ErrorBoundary>
            <Dialog fullHeight={true} title={t('orders:dialog.title')} onClose={props.onClose}>
                <div className={css.container}>
                    <OrderCard
                        order={order}
                        userRole={UserRole.VENDOR}
                        isPending={!isUIEnabled}
                        onIntent={intent => action(makeOrderChangeStatusAction, order.orderId, intent)}
                    />
                    <Box m={2}>
                        <OrderCustomerPhone userRole={UserRole.CUSTOMER} phoneNumber={(order as any)?.username} />
                    </Box>
                </div>
            </Dialog>
        </ErrorBoundary>
    );
};
